import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';

import componentStyles from './ghs-rate.css.lit';
import '../ghs-icon/ghs-icon';

/**
 * Tag Component
 * @element ghs-rate
 */
@customElement('ghs-rate')
export class GhsRate extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Star icon size
   */
  @property({ type: Number, attribute: 'icon-size' }) iconSize = 20;

  /**
   * Star mobile icon size
   */
  @property({ type: Number, attribute: 'icon-mobile-size' })
  iconMobileSize: number;

  /**
   * Default value
   * @param url
   */
  @property({ type: Number, attribute: 'value' })
  value = 0;

  renderStars() {
    const minValue = Math.floor(this.value);
    const items = Array.from({ length: 5 });
    const decimal = Math.round((this.value - minValue) * 100);

    return items.map((_, index) => {
      if (minValue > index) {
        return html` <ghs-icon
          class="star star--active"
          name="star"
          size="${this.iconSize}px"
          mobile-size="${this.iconMobileSize || this.iconSize}px"
          site=${this.site}
        ></ghs-icon>`;
      }

      if (this.value > index) {
        return html`<div class="star-wrapper">
          <ghs-icon
            class="star--active"
            name="star"
            size="${this.iconSize}px"
            mobile-size="${this.iconMobileSize || this.iconSize}px"
            style="width:${decimal}%"
            site=${this.site}
          ></ghs-icon>
          <ghs-icon
            class="star"
            name="star"
            size="${this.iconSize}px"
            mobile-size="${this.iconMobileSize || this.iconSize}px"
            site=${this.site}
          ></ghs-icon>
        </div> `;
      }

      return html` <ghs-icon
        class="star"
        name="star"
        size="${this.iconSize}px"
        mobile-size="${this.iconMobileSize || this.iconSize}px"
        site=${this.site}
      ></ghs-icon>`;
    });
  }

  render(): TemplateResult {
    return html`
      <div class="rate" title="${this.value}">${this.renderStars()}</div>
    `;
  }
}
